import { render, staticRenderFns } from "./change-status.vue?vue&type=template&id=e84e4f48&scoped=true"
import script from "./change-status.vue?vue&type=script&lang=js"
export * from "./change-status.vue?vue&type=script&lang=js"
import style0 from "./change-status.vue?vue&type=style&index=0&id=e84e4f48&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e84e4f48",
  null
  
)

export default component.exports